import { 
    Paid, 
    Sell, 
    TouchApp, 
    SupervisorAccount, 
    NoteAdd, 
    Psychology, 
    Group,
    Map
} from "@mui/icons-material";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import { DrawerItem } from "./drawerTypes";

export const DrawerItems: DrawerItem[] = [
    {
        label: 'Dashboard',
        path: '/Dashboard',
        icon: 'fa fa-lg fa-dashboard',
        iconType: 'fa',
        type: 'link',
    },
    {
        label: 'Orders & Bids',
        path: '/Orders+Bids',
        icon: faBoxOpen,
        iconType: 'fa-comp',
        type: 'link',
    },
    {
        label: 'Sales Rep View',
        path: '/SalesRepView',
        icon: SupervisorAccount,
        iconType: 'mui',
        requirements: {
            permission: 'changeWriterCode',
            level: 'READ'
        },
        type: 'link',
    },
    {
        label: 'Sell-A-Thon',
        path: '/SellAThon',
        icon: 'fa fa-lg fa-arrow-left',
        iconType: 'fa',
        type: 'back',
    },
    {
        label: 'Sales Report',
        path: '/SalesReport',
        icon: Paid,
        iconType: 'mui',
        type: 'link',
    },
    {
        label: 'Promotions',
        path: '/Promotions',
        icon: Sell,
        iconType: 'mui',
        type: 'link',
    },
    {
        label: 'CRM Entry',
        path: '/CrmEntry',
        icon: NoteAdd,
        iconType: 'mui',
        type: 'link',
    },
    {
        label: 'Nudge Report',
        path: '/Nudges',
        icon: TouchApp,
        iconType: 'mui',
        type: 'link',
    },
    {
        label: 'NudgeDetail',
        path: '/Nudges/',
        icon: 'fa fa-lg fa-arrow-left',
        iconType: 'fa',
        type: 'back',
    },
    {
        label: 'Customers',
        path: '/Customers',
        icon: Group,
        iconType: 'mui',
        type: 'link',
    },
    {
        label: 'CustomerDetail',
        path: '/Customers/',
        icon: 'fa fa-lg fa-arrow-left',
        iconType: 'fa',
        type: 'back',
    },
    {
        label: 'Locations',
        path: '/Locations',
        icon: Map,
        iconType: 'mui',
        type: 'link',
    },
    {
        label: 'LocationDetail',
        path: '/Locations',
        icon: 'fa fa-lg fa-arrow-left',
        iconType: 'fa',
        type: 'back',
    },
    {
        label: 'SDS',
        path: '/SDS',
        icon: 'fa fa-lg fa-file',
        iconType: 'fa',
        type: 'link',
    },
    {
        label: 'My Account',
        path: '/MyAccount',
        icon: 'fa fa-lg fa-user',
        iconType: 'fa',
        type: 'link',
    },
    // {
    //     label: 'AskJiro',
    //     path: '/AskJiro',
    //     icon: Psychology,
    //     iconType: 'mui',
    //     type: 'link',
    // },
    // {
    //     label: 'PIM Agent',
    //     path: '/PIM',
    //     icon: Psychology,
    //     iconType: 'mui',
    //     type: 'link',
    // },
];
